<header-bar pageTitle="Latest updates" headingClass="fa-calendar-o" [buttons]="headerButtons"></header-bar>

<div class="container mt-5">
    <div class="row">
        <div class="col">
            <div class="card">
                <div class="card-header bg-primary text-white">
                    <div class="row">
                        <div class="col-sm-8">
                            <p class="h3 m-0">Manage updates</p>
                        </div>
                        <div class="col-sm-4 text-right">
                            <button type="button" class="btn btn-outline-light btn-sm"
                                (click)="showHideDisableUpdates()">
                                <span *ngIf="hideDisableUpdates">Show disabled updates</span>
                                <span *ngIf="!hideDisableUpdates">Hide disabled updates</span>
                                <i class="fa fa-filter ml-2"></i>
                            </button>
                        </div>
                    </div>
                </div>

                <div class="card-body">
                    <table class="table">
                        <colgroup>
                            <col class="col-auto">
                            <col class="col-auto">
                            <col class="col-auto">
                            <col class="col-auto">
                        </colgroup>
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Location</th>
                                <th>Update</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let update of latestUpdates">
                                <td [ngClass]="{'table__cell--disabled': update.disabled}">
                                    {{update.createdDate | date : 'd MMMM y'}}</td>
                                <td [ngClass]="{'table__cell--disabled': update.disabled}">
                                    <strong>{{update.countryName}}</strong></td>
                                <td [ngClass]="{'table__cell--disabled': update.disabled}"><span
                                        [innerHtml]="update.description"></span></td>
                                <td (click)="editClicked(update)" class="text-right"><i
                                        class="btn btn-icon fa fa-pencil btn"></i></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>